

//Représente des informations d'indentification d'un utilisateur
export interface AloUserIdentity {
    userEmail:string
    userPass:string
}

export const getDefaultAloUserIdentity = ():AloUserIdentity => {
    return {        
        userEmail:"",
        userPass:""
    }
}